<div *ngIf="isReady" class="field" [ngClass]="{'field-page': type === 'page'}">
	<div class="info-row">
		<status-icon
			*ngIf="type === 'page'"
			[number]="1"
			[complete]="formField?.status === 'VALID'"
            ></status-icon>
		<div class="wrap-group">
			<div class="info">{{ 'PROMPTUARY.REASONS' | translate }}*</div>
			<div class="subinfo">{{ 'PROMPTUARY.REASONS_H2' | translate }}</div>
		</div>
	</div>
	<div class="zk-mt-2">
		<freud-multi-select
			[disabled]="readonly"
			(onChange)="onChangeReasons($event)"
			display="chip"
			[(ngModel)]="_value"
			[options]="_options"
			[placeholder]="'SCHEDULE.REASONS.NO_REASONS_SELECTED' | translate"
		></freud-multi-select>
		<div
			class="reasons-sugestion zk-mt-3"
			*ngIf="isReasonsSugestionOpen && _lastAppointmentReasons?.length > 0"
		>
			<div class="zk-flex zk-flex-col zk-gap-2">
				<span class="reasons-sugestion__title">{{
					'SCHEDULE.REASONS.LAST_SESSION_REASONS' | translate
				}}</span>
				<div class="reasons__tags-wrapper">
					<div
						(click)="addReason(reason.value)"
						class="reason-tag"
						*ngFor="let reason of _lastAppointmentReasons"
					>
						<span>{{ reason.label }}</span>
						<span class="freud-icon freud-icon-plus"></span>
					</div>
				</div>
			</div>
			<span
				(click)="isReasonsSugestionOpen = false"
				class="zk-mt-1 freud-icon freud-icon-close"
			></span>
		</div>
	</div>
</div>
